import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { FavourTournamentQuestion, FavourTournamentQuestionAnswer, FavourTournamentQuestionListResponse, FavourTournamentQuestionPair, FavourTournamentRoundsResponse } from "src/app/interfaces/favour-tournament-question";
import { environment } from "src/environments/environment";
import { CustomHttpClient } from "../http/http.service";

@Injectable({
  providedIn: "root"
})
export class FavourTournamentQuestionService {
  constructor(private http: CustomHttpClient) { }
  
  getQuestionList(questionGroupId: number, round?: number): Observable<FavourTournamentQuestionListResponse> {
    const queryParams = { round: round ?? null };
    return this.http.get<FavourTournamentQuestionListResponse>(
      `${environment.apiUrl}/v2/question-groups/favour-tournament/${questionGroupId}/questions`, { queryParams }
    )
  }

  getNextQuestionPairs(totalPairs: FavourTournamentQuestionPair[], answers: FavourTournamentQuestionAnswer[], nextStage: number): FavourTournamentQuestionPair[] {
    const currentPairs = answers.filter((answer) => answer.stage / 2 === nextStage)
    const winners: number[] = currentPairs.map((pair) => pair.selectedQuestionId)
    const newPairs = totalPairs
      .reduce((acc, cur) => {
        acc.push(cur.leftQuestion)
        acc.push(cur.rightQuestion)
        return acc
      }, [] as FavourTournamentQuestion[])
      .filter((question) => winners.includes(question.id))
      .reduce((acc, cur) => {
        if (acc.length > 0 && !acc[acc.length - 1]?.rightQuestion) {
          acc[acc.length - 1].rightQuestion = cur
        } else {
          acc.push({ leftQuestion: cur })
        }
        return acc
      }, [] as Partial<FavourTournamentQuestionPair>[])
    return newPairs as FavourTournamentQuestionPair[]
  }

  getTournamentRounds(questionGroupId: number): Observable<FavourTournamentRoundsResponse> {
    return this.http.get<FavourTournamentRoundsResponse>(`${environment.apiUrl}/v2/question-groups/favour-tournament/${questionGroupId}/rounds`)
  }

}